<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="物件名称">
                  <el-input style="width: 200px" v-model="queryForm.productName"></el-input>
              </el-form-item>
              <el-form-item label="物件分类">
<!--                  <el-input  v-model="queryForm.categoryId"></el-input>-->
                  <el-select
                      clearable
                      style="width: 200px"
                      v-model="queryForm.categoryId"
                      placeholder="请选择"
                      size="small"
                  >
                      <el-option
                          v-for="item in washProductCategoryList"
                          :label="item.categoryName"
                          :value="item.id"
                      > </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="存储区域">
<!--                  <el-input style="width: 200px" v-model="queryForm.storageId"></el-input>-->
                  <el-select
                      clearable
                      style="width: 200px"
                      v-model="queryForm.storageId"
                      placeholder="请选择"
                      size="small"
                  >
                      <el-option
                          v-for="item in washStorageAreaList"
                          :label="item.areaName"
                          :value="item.id"
                      > </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getWashProductList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addWashProduct"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editWashProduct(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteWashProduct(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshWashProductList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="washProductList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="productName"
        label="物件名称"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="categoryId"
        label="物件分类"
        width="180"
      >
          <template slot-scope="scope">
              {{scope.row.category ? scope.row.category.categoryName : ''}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="storageId"
        label="存储区域"
        width="180"
      >
          <template slot-scope="scope">
              {{scope.row.storage ? scope.row.storage.areaName : ''}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="productPic"
        label="图片"
        width="180"
      >
          <template slot-scope="scop">
              <el-image
                  @click='updateSrcList(scop.row.productPic)'
                  style="width: 30px; height: 30px"
                  :src="scop.row.productPic"
                  :preview-src-list="srcList"
              > </el-image>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="shortcut"
        label="快捷键"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="measureUnit"
        label="测量单位"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkWashProduct(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editWashProduct(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteWashProduct(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="washProductStates[washProductState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="washProduct"
          ref="washProductForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="物件名称"
            prop="productName"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="washProduct.productName"
              :disabled="washProductState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="物件分类"
            prop="categoryId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="washProduct.categoryId"-->
<!--              :disabled="washProductState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  clearable
                  style="width: 200px"
                  v-model="washProduct.categoryId"
                  placeholder="请选择"
                  :disabled="washProductState == 'check'"
                  size="small"
              >
                  <el-option
                      v-for="item in washProductCategoryList"
                      :label="item.categoryName"
                      :value="item.id"
                  > </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="存储区域"
            prop="storageId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="washProduct.storageId"-->
<!--              :disabled="washProductState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  clearable
                  style="width: 200px"
                  v-model="washProduct.storageId"
                  placeholder="请选择"
                  :disabled="washProductState == 'check'"
                  size="small"
              >
                  <el-option
                      v-for="item in washStorageAreaList"
                      :label="item.areaName"
                      :value="item.id"
                  > </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="图片"
            prop="productPic"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 200px"-->
<!--              v-model="washProduct.productPic"-->
<!--              :disabled="washProductState == 'check'"-->
<!--            ></el-input>-->
<!--              <el-upload-->
<!--                  action=""-->
<!--                  :disabled="washProductState == 'check'"-->
<!--                  class="avatar-uploader"-->
<!--                  :show-file-list="false"-->
<!--                  :http-request="uploadAvatar"-->
<!--                  style="width: 200px"-->
<!--              >-->
<!--                  <img-->
<!--                      v-if="washProduct.productPic"-->
<!--                      :src="washProduct.productPic"-->
<!--                      class="avatar"-->
<!--                  />-->
<!--                  <i-->
<!--                      v-else-->
<!--                      class="el-icon-plus avatar-uploader-icon"-->
<!--                  ></i>-->
<!--              </el-upload>-->
              <div style="width: 200px;display: flex;align-items: center;">
                  <el-input :disabled="washProductState == 'check'" v-model="washProduct.productPic" size="small"></el-input>
                  <el-button :disabled="washProductState == 'check'" type="primary" size="small" style="margin-left: 2px;" @click="uploadImages()">上传图片
                      <el-upload :action="action" :headers="header" v-show="false" :before-upload="beforeImageUpload" ref="uploads" class="avatar-uploader" :show-file-list="false"
                          :http-request="uploadAvatar">
                          <el-button type="primary" size="small" class="as">上传</el-button>
                      </el-upload>
                  </el-button>
              </div>
          </el-form-item>
          <el-form-item
            label="排序"
            prop="sort"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="washProduct.sort"
              :disabled="washProductState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="快捷键"
            prop="shortcut"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="washProduct.shortcut"
              :disabled="washProductState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="测量单位"
            prop="measureUnit"
          >
<!--            <el-input-->
<!--              style="width: 200px"-->
<!--              size="small"-->
<!--              v-model="washProduct.measureUnit"-->
<!--              :disabled="washProductState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  clearable
                  style="width: 200px"
                  v-model="washProduct.measureUnit"
                  placeholder="请选择"
                  :disabled="washProductState == 'check'"
                  size="small"
              >
                  <el-option
                      v-for="item in measureUnitList"
                      :label="item.value"
                      :value="item.key"
                  > </el-option>
              </el-select>
          </el-form-item>
        </el-form>

          <!-- 列表数据 -->
          <el-table
              :data="washProduct.servicePriceList"
              row-key="id"
              border
              height="400px"
              :header-row-style="{height: '10px'}"
              :header-cell-style="{padding: '10px'}"
              :row-style="{height: '9px'}"
              :cell-style="{padding: '10px 0px'}"
              size="small"
          >
              <el-table-column
                  :show-overflow-tooltip="true"
                  align="center"
                  prop="serviceId"
                  label="服务"
                  min-width="100"
              >
                  <template slot-scope="scope">
                      {{scope.row.service.serviceName}}
                  </template>
              </el-table-column>
              <el-table-column
                  :show-overflow-tooltip="true"
                  align="center"
                  prop="servicePrice"
                  label="价格"
                  min-width="120"
              >
                  <template slot-scope="scope">
                      <el-input size="small" type="text" v-model="scope.row.servicePrice" :disabled="washProductState == 'check'"/>
                  </template>
              </el-table-column>
              <el-table-column
                  :show-overflow-tooltip="true"
                  align="center"
                  prop="allowChange"
                  label="允许改价"
                  min-width="120"
              >
                  <template slot-scope="scope">
<!--                      <el-select-->
<!--                          clearable-->
<!--                          v-model="scope.row.allowChange"-->
<!--                          placeholder="请选择"-->
<!--                          :disabled="washProductState == 'check'"-->
<!--                          size="small"-->
<!--                      >-->
<!--                          <el-option-->
<!--                              label="不允许"-->
<!--                              :value="0"-->
<!--                          > </el-option>-->
<!--                          <el-option-->
<!--                              label="允许"-->
<!--                              :value="1"-->
<!--                          > </el-option>-->
<!--                      </el-select>-->
                      <el-switch
                          :disabled="washProductState == 'check'"
                          v-model="scope.row.allowChange"
                          active-color="#13ce66"
                          :active-value="1"
                          :inactive-value="0"
                          inactive-color="#ff4949">
                      </el-switch>
                  </template>
              </el-table-column>
              <el-table-column
                  :show-overflow-tooltip="true"
                  align="center"
                  prop="minPrice"
                  label="最小价格"
                  min-width="120"
              >
                  <template slot-scope="scope">
                      <el-input size="small" type="text" v-model="scope.row.minPrice" :disabled="washProductState == 'check'"/>
                  </template>
              </el-table-column>
              <el-table-column
                  :show-overflow-tooltip="true"
                  align="center"
                  prop="maxPrice"
                  label="最大价格"
                  min-width="120"
              >
                  <template slot-scope="scope">
                      <el-input size="small" type="text" v-model="scope.row.maxPrice" :disabled="washProductState == 'check'"/>
                  </template>
              </el-table-column>
              <el-table-column
                  :show-overflow-tooltip="true"
                  align="center"
                  prop="isDefault"
                  label="默认"
                  min-width="100"
              >
                  <template slot-scope="scope">
                      <span @click="setRadio(scope.$index)" :class="scope.row.isDefault === 1 ? 'el-radio__input is-checked' : 'el-radio__input'">
                          <span class="el-radio__inner">

                          </span>
                      </span>
                  </template>
              </el-table-column>
          </el-table>

      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="washProductState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import {
    exprotExcel,
    importTemplate,
    importDate,
    get,
    post,
    put,
    deleteFun,
    upload,
    postJson
} from '@/utils/request.js';
import { UPLOAD_API, UPLOAD_PATH } from '@/utils/constant';
import { forEach } from 'vue-print-nb/lib/print.common';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetWashProductList();
                    this.getWashProductList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetWashProductList();
                    this.getWashProductList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     productName: '', //物件名称
                     categoryId: '', //物件分类
                     storageId: '', //存储区域
                     productPic: '', //图片
                     sort: '', //排序
                     shortcut: '', //快捷键
                     measureUnit: '', //测量单位
                },
                header: {
                    token: localStorage.getItem('token')
                },
                action: UPLOAD_API + UPLOAD_PATH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                washProductState: 'add',
                washProductStates: {
                    add: '新建物件设置',
                    check: '查看物件设置',
                    edit: '修改物件设置'
                },

                multipleSelection: [],
                washProductList: [],
                washProduct: {
                    id: '', //ID
                    productName: '', //物件名称
                    categoryId: '', //物件分类
                    storageId: '', //存储区域
                    productPic: '', //图片
                    sort: '', //排序
                    shortcut: '', //快捷键
                    measureUnit: '', //测量单位
                    createTime: '', //创建时间
                    servicePriceList: [],
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    productName: [{ required: true, message: '物件名称不能为空', trigger: 'blur' }],
                    categoryId: [{ required: true, message: '物件分类不能为空', trigger: 'blur' }],
                    storageId: [{ required: true, message: '存储区域不能为空', trigger: 'blur' }],
                    productPic: [{ required: true, message: '图片不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                    //shortcut: [{ required: true, message: '快捷键不能为空', trigger: 'blur' }],
                    measureUnit: [{ required: true, message: '测量单位不能为空', trigger: 'blur' }],
                },
                washProductCategoryList: [],
                washStorageAreaList: [],
                srcList: [''],
                measureUnitList: [],
                rowRadio: null
            };
        },
        created() {
            this.getWashProductList();
            this.getTwoList()
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            setRadio(index){
                if(String(index) === String(this.rowRadio)){
                    return
                }
                for (let item of this.washProduct.servicePriceList) {
                    item.isDefault = 0
                }
                this.washProduct.servicePriceList[index].isDefault = 1
                this.rowRadio = index
            },
            beforeImageUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 50;
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 50MB!');
                }
                return isLt2M;
            },
            uploadImages(id) {
                this.$refs.uploads.$el.querySelector(".as").click()
                // console.log(this.$refs.uploads)
            },
            updateSrcList(src){
                this.srcList[0] = src
            },
            uploadAvatar(params) {
                console.log({ params });
                const file = params.file;
                let types = ['image/jpeg', 'image/png', 'image/jpg'];
                if (!types.includes(file.type)) {
                    this.$message({
                        message: '只能上传图片格式的文件，png.jpg或者jpeg',
                        type: 'error',
                        duration: 2000
                    });
                }
                const formData = new FormData();
                formData.append('file', file);
                console.log({ formData });
                upload(`/mpp/image/upload`, formData).then((res) => {
                    console.log({ res });
                    if (res.success) {
                        this.washProduct.productPic = res.url;
                    }else{
                        this.$message({
                            message: res.message,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            // 获取两个列表
            getTwoList(){
                get('/wash/storagearea/findAll').then((res)=>{
                    if(res.success){
                        this.washStorageAreaList = res.list;
                    }
                })
                get('/wash/productcategory/findAll').then((res)=>{
                    if(res.success){
                        this.washProductCategoryList = res.list;
                    }
                })
                get('/wash/utils/getEnum?enumType=measure_unit').then((res)=>{
                    if(res.success){
                        this.measureUnitList = res.enumList;
                    }
                })
            },
            resetWashProductList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.washProductList = [];
            },
            resetDialog() {
                this.washProductState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      productName: '', //物件名称
                      categoryId: '', //物件分类
                      storageId: '', //存储区域
                      productPic: '', //图片
                      sort: '', //排序
                      shortcut: '', //快捷键
                      measureUnit: '', //测量单位
                };
                this.getWashProductList();
            },
            closeDialog() {
                this.showDialog = false
                this.washProduct = {
                      id: '', //ID
                      productName: '', //物件名称
                      categoryId: '', //物件分类
                      storageId: '', //存储区域
                      productPic: '', //图片
                      sort: '', //排序
                      shortcut: '', //快捷键
                      measureUnit: '', //测量单位
                      createTime: '', //创建时间
                };
                this.rowRadio = null
            },
            submitForm() {
                if (this.washProductState == 'add') {
                    this.$refs.washProductForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            // this.getRadio()
                            postJson(`/wash/product/add`,{ ...this.washProduct }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetWashProductList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.washProductState == 'edit') {
                    this.$refs.washProductForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.washProduct.category
                            delete this.washProduct.storage
                            // this.getRadio()
                            postJson(`/wash/product/edit`,{ ...this.washProduct }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetWashProductList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addWashProduct() {
                this.showDialog = true;
                this.washProductState = 'add';
                this.getTableSpeedNames();
            },
            getTableSpeedNames(id){
                this.washProduct.servicePriceList = []
                let obj = {}
                if(id){
                    obj.productId = id
                }
                get('/wash/serviceprice/findAllByProductId',obj).then((res)=>{
                    if(res.success){
                        this.washProduct.servicePriceList = res.list;
                        this.$forceUpdate()
                    }
                })
            },
            checkWashProduct(washProductId) {
                console.log(washProductId);
                this.currentWashProductId = washProductId;

                this.getWashProductById();
                this.showDialog = true;
                this.washProductState = 'check';
            },
            editWashProduct(washProductId) {
                console.log('washProduct', washProductId);
                if (washProductId) {
                    this.currentWashProductId = washProductId;
                    this.getWashProductById();
                } else {
                    this.washProduct = { ...this.washProduct, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.washProductState = 'edit';
            },
            deleteWashProduct(washProductId) {
                let ids = '';
                if (washProductId) {
                    ids = washProductId;
                } else {
                    ids = this.multipleSelection.map((washProduct) => washProduct.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/wash/product/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetWashProductList();
                                this.getWashProductList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshWashProductList() {
                this.resetWashProductList();
                this.getWashProductList();
            },
            getWashProductList(query = {}) {
                this.loading = true;
                get(`/wash/product/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.washProductList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getWashProductById() {
                get(`/wash/product/get`,{ id: this.currentWashProductId }).then((res) =>{
                    if(res.success){
                      this.washProduct = { ...this.washProduct, ...res.washProduct };
                      this.getTableSpeedNames(this.washProduct.id)
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportWashProductList() {
                //this.btnLoading = true;
                exprotExcel(`/wash/product/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/wash/product/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/wash/product/importData`,formData);
              this.refreshWashProductList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getWashProductList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getWashProductList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 200px;
    text-align: center;
}
.avatar {
    width: 200px;
    height: 200px;
    display: block;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>